<div #chipContainer class="facet-pills-container">
  <div *ngIf="listFacet?.isValuesSelected">
    <ng-container *ngFor="let value of listFacet?.values | keyvalue">
      <app-usf-chip
        class="chip-class"
        #NewSearchFacetChip
        [clickable]="true"
        [type]="chipTypeEnum.selectedFilter"
        [iconConfig]="{
          rightIcon: true,
          color: '#56821f',
          iconUrl: 'assets/images/filter-selected-close.svg',
        }"
        (clickEmitter)="handleListChipClick(value?.value)"
      >
        {{ value?.value?.value | titlecase }}
      </app-usf-chip>
    </ng-container>
  </div>
  <div *ngFor="let facetChip of facetChipsToShow">
    <app-usf-chip
      #NewSearchFacetChip
      [clickable]="true"
      [type]="chipTypeEnum.selectedFilter"
      [iconConfig]="{
        rightIcon: true,
        color: '#56821f',
        iconUrl: 'assets/images/filter-selected-close.svg',
      }"
      (clickEmitter)="handleChipClick(facetChip)"
    >
      {{ facetChip.facetValue.value | titlecase }}
    </app-usf-chip>
  </div>
  <div>
    <app-usf-chip
      [clickable]="true"
      [type]="chipTypeEnum.noIconFacet"
      [iconConfig]="{
        rightIcon: false,
      }"
      (clickEmitter)="handleAdditionalButtonClick()"
      *ngIf="facetChipViewModels.length > facetChipsToShow.length"
    >
      {{ additionalFacetsMessage }}
    </app-usf-chip>
  </div>
</div>
